// @flow

import type { Question } from './types';

export const isQuestionValid = (question: Question): boolean => {
  return (
    question.title.length > 0 &&
    question.description.length > 0 &&
    (question.content.isValid == null || question.content.isValid)
  );
};



// WEBPACK FOOTER //
// ./src/modules/survey/helpers.js